import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OverlayArrow } from "react-aria-components";
import { StyledTooltip } from "./styled";
const Tooltip = ({ children }) => (_jsxs(StyledTooltip, { children: [_jsx(OverlayArrow, { children: _jsx("svg", { height: 8, viewBox: "0 0 8 8", width: 8, children: _jsx("path", { d: "M0 0 L4 4 L8 0" }) }) }), children] }));
export default Tooltip;
